import React from 'react';
import ServicePage from './ServicePage';
import { IconShieldCheck, IconLeaf, IconDroplet } from '../../components/Icons';

const DATA = {
  icon: <IconShieldCheck size={32} />, category: 'ambiental',
  title: 'ICAS – Informe de Cumplimiento Ambiental',
  subtitle: 'Elaboración y presentación del Informe de Cumplimiento de Obligaciones Ambientales ante las autoridades competentes.',
  norm: 'Ley 99 de 1993 – Decreto 2820 de 2010',
  desc: 'Elaboramos el Informe de Cumplimiento de las Obligaciones Ambientales (ICAS) requerido por las corporaciones autónomas regionales y el ANLA, en los términos y plazos establecidos en licencias ambientales, planes de manejo y permisos concedidos.',
  details: [
    'Recopilación y análisis de datos ambientales del periodo',
    'Verificación del cumplimiento de obligaciones',
    'Monitoreo de calidad del aire, agua y suelo',
    'Elaboración de indicadores de gestión ambiental',
    'Identificación de no conformidades y medidas correctivas',
    'Presentación ante CORPOBOYACÁ, CAR u otra autoridad',
  ],
  related: [
    { icon: <IconLeaf size={18} />,    label: 'PMA',              path: '/servicios/pma' },
    { icon: <IconDroplet size={18} />, label: 'Estudios de Aguas', path: '/servicios/estudios-aguas' },
  ],
};

export default function ICAS() { return <ServicePage data={DATA} />; }
